import { useQuery } from 'react-query';

import {
  ForumPostsResult,
  USER_FORUM_POSTS_KEY,
  getForumPosts,
} from '@utils/backend-api/forumPosts';

interface UserForumPostOptions {
  userId: number;
  order?: string;
}

export default function useUserForumPosts({ userId, order }: UserForumPostOptions) {
  const { data, isLoading: areForumPostsLoading } = useQuery<ForumPostsResult>(
    [USER_FORUM_POSTS_KEY, userId],
    () => getForumPosts({ userId, order })
  );

  return { forumPosts: data?.forum_posts, areForumPostsLoading };
}
